export const SITE_ID_QUERY_PARAM = 'siteId';
export const SITE_NAME_QUERY_PARAM = 'siteName';

const ENROLLING_FRAGMENT = 'f-trialenrollingstatus=Enrolling';

export type FindTrialSiteParams = {
  siteId?: string;
  siteName?: string;
};

const withEnrollingHash = (href: string): string => {
  if (href.includes('f-trialenrollingstatus=')) {
    return href;
  }
  return href.includes('#') ? `${href}&${ENROLLING_FRAGMENT}` : `${href}#${ENROLLING_FRAGMENT}`;
};

/**
 * Appends siteId + siteName onto the Find Trials href and the enrolling facet hash.
 * siteId is required; without it this is a normal Find Trials link.
 */
export const withFindTrialsSiteParams = (
  href: string,
  params?: { siteId?: string; siteName?: string }
): string => {
  if (!href || !params?.siteId) {
    return href;
  }

  const hashIndex = href.indexOf('#');
  const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? href.slice(0, hashIndex) : href;

  const search = new URLSearchParams();
  search.set(SITE_ID_QUERY_PARAM, params.siteId);
  if (params.siteName) {
    search.set(SITE_NAME_QUERY_PARAM, params.siteName);
  }

  const separator = withoutHash.includes('?') ? '&' : '?';
  return withEnrollingHash(`${withoutHash}${separator}${search.toString()}${hash}`);
};

/** Values the Find Trials page was opened with. Empty on the server and on a cold start. */
export const getFindTrialsSiteParams = (): FindTrialSiteParams => {
  if (typeof window === 'undefined') {
    return { siteId: '', siteName: '' };
  }

  const search = new URLSearchParams(window.location.search);
  return {
    siteId: (search.get(SITE_ID_QUERY_PARAM) ?? '').trim(),
    siteName: (search.get(SITE_NAME_QUERY_PARAM) ?? '').trim(),
  };
};

/** Chip X: drop site lock from the URL, keep path/hash/other query params. */
export const clearFindTrialsSiteParamsFromUrl = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete(SITE_ID_QUERY_PARAM);
  url.searchParams.delete(SITE_NAME_QUERY_PARAM);
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
};
